import { render, staticRenderFns } from "./ServicesAvailed.vue?vue&type=template&id=31274a1f&"
import script from "./ServicesAvailed.vue?vue&type=script&lang=js&"
export * from "./ServicesAvailed.vue?vue&type=script&lang=js&"
import style0 from "./ServicesAvailed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports